import { useEffect, useRef } from "react";

export const AD_CLIENT = "ca-pub-0287786073593853";

/**
 * Unidad de AdSense.
 *
 * Tres cosas que el código anterior no hacía:
 *  1. Reservar la altura antes de que cargue el anuncio (evita CLS).
 *  2. Empujar una sola vez por elemento. En una SPA, volver a montar el
 *     mismo <ins> y empujarlo otra vez provoca el error
 *     "All ins elements already have ads in them".
 *  3. No renderizar nada si la página no tiene contenido propio: servir
 *     anuncios en una página vacía infringe las políticas de AdSense.
 */
export default function AdSlot({ slot, formato = "auto", className = "", etiqueta = true }) {
  const ref = useRef(null);
  const empujado = useRef(false);

  useEffect(() => {
    if (empujado.current) return;
    const el = ref.current;
    if (!el || el.getAttribute("data-adsbygoogle-status")) return;

    // Sin ancho no hay anuncio: AdSense lo descarta y la ranura queda
    // muerta hasta la siguiente navegación.
    if (el.offsetWidth === 0) return;

    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
      empujado.current = true;
    } catch (e) {
      if (import.meta.env.DEV) console.warn("AdSense no pudo cargar la ranura", slot, e);
    }
  }, [slot]);

  if (!slot) return null;

  return (
    <div className={`no-imprimir ${className}`}>
      {etiqueta && (
        <span className="texto-3 mb-1.5 block text-center text-[10px] uppercase tracking-[0.12em]">
          Publicidad
        </span>
      )}
      <div className="ranura-anuncio">
        <ins
          ref={ref}
          className="adsbygoogle"
          style={{ display: "block", width: "100%" }}
          data-ad-client={AD_CLIENT}
          data-ad-slot={slot}
          data-ad-format={formato}
          data-full-width-responsive="true"
        />
      </div>
    </div>
  );
}

/**
 * Ranuras declaradas en un solo sitio.
 *
 * `listado` es la única que existía en producción. Las demás hay que
 * crearlas en el panel de AdSense y pegar aquí su ID: mientras el valor
 * sea null el componente no renderiza nada, así que es seguro
 * desplegar antes de tenerlas.
 */
export const RANURAS = {
  listado: "6061608942",
  resultado: null, // in-article, debajo del resultado del cálculo
  contenido: null, // dentro del artículo explicativo
  lateral: null, // barra lateral en escritorio
};
